'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultTunnel = exports.reducers = exports.getTunnel = exports.default = undefined;

var _selectors = require('./selectors');

Object.defineProperty(exports, 'default', {
    enumerable: true,
    get: function get() {
        return _selectors.tunnelSelector;
    }
});
Object.defineProperty(exports, 'getTunnel', {
    enumerable: true,
    get: function get() {
        return _selectors.getTunnel;
    }
});

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var reducers = {
    tunnel: _reducer2.default
};

exports.reducers = reducers;
exports.defaultTunnel = _reducer.defaultTunnel;

// types
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-tunnel/dist/main/index.js
// module id = 112
// module chunks = 0